import {Box, SimpleGrid, Text, useRadioGroup} from "@chakra-ui/react";
import RadioCard from "../../components/radio-card/RadioCard";
import Step from "../../components/step/Step";
import {useNavigate} from "react-router-dom";

import habitsImage1 from '../../assets/step10/icon1.png';
import habitsImage2 from '../../assets/step10/icon2.png';
import habitsImage3 from '../../assets/step10/icon3.png';
import habitsImage4 from '../../assets/step10/icon4.png';
import { translation } from "../../utils/translation";

function Step11() {
    let navigate = useNavigate();

    const {getRootProps, getRadioProps} = useRadioGroup({
        name: 'q11',
        onChange: () => {
            navigate('../step12', {replace: true});
        }
    });

    const options = [
        {
            'id': 'a1',
            'icon': habitsImage1,
            'text': translation("general.step11.option1")
        },
        {
            'id': 'a2',
            'icon': habitsImage2,
            'text': translation("general.step11.option2")
        },
        {
            'id': 'a3',
            'icon': habitsImage3,
            'text': translation("general.step11.option3")
        },
        {
            'id': 'a4',
            'icon': habitsImage4,
            'text': translation("general.step11.option4")
        }
    ];

    const group = getRootProps()

    return (
        <Step heading={translation("general.step11.headline")}
              currentStep={8}
              backLink={'/step9'}>
            <SimpleGrid mt={5} spacing={2} columns={1} {...group}>
                {options.map((value) => {
                    const radio = getRadioProps({'value': value.id})
                    return (
                        <RadioCard key={value.id} {...radio}>
                            <Box display={'flex'} alignItems={'center'}>
                                <Box mr={5}>
                                    <img height={100} width={100} src={value.icon} alt=''/>
                                </Box>
                                <Text fontSize={'lg'} fontWeight={'bold'} mt={3}>{value.text}</Text>
                            </Box>
                        </RadioCard>
                    )
                })}
            </SimpleGrid>
        </Step>
    );
}

export default Step11;
